import { createSlice } from "@reduxjs/toolkit";
import { setChatHistoryThunk } from "./chatThunk";

const initialState = {
    chatHistory: [],
    isOpen: false
};

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        openChat: (state) => {
            state.isOpen = true;
        },
        closeChat: (state) => {
            state.isOpen = false;
        },
        setChatHistory: (state, action) => {
            state.chatHistory = action.payload;
        },
        clearChatHistory: (state, action) => {
            state.chatHistory = [];
            state.isOpen = false;
        },
        clearChatHistoryOnly: (state, action) => {
            state.chatHistory = [];
            // Don't change isOpen state - leave it as is
        }
    },
    extraReducers: (builder) => {

        builder
            .addCase(setChatHistoryThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(setChatHistoryThunk.fulfilled, (state, action) => {
                state.loading = false;
                console.log(`setChatHistoryThunk::`, action.payload);
                // Update the socialfeed state with the new data
                if (action.payload?.data?.aiMessages) {
                    state.chatHistory = action.payload?.data?.aiMessages;
                }
            })
            .addCase(setChatHistoryThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default chatSlice.reducer;

export const { setChatHistory, clearChatHistory, clearChatHistoryOnly, openChat, closeChat } = chatSlice.actions;
